import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loader from "./components/loader"
import PasswordInput from "./components/passwordInput"
import URLBASE from "../api/urlRegister"
import {checaFormatoSenha} from "./util/utils"
import '../App.css';

const initialState = {
	email: '',
	senha: '',
	pinUsuario: '',
}

const RecuperarSenha = () => {
	
	const navigate = useNavigate()
	const location = useLocation()
	
	const notificationError = message => toast.error(message);
	const notificationSuccess = message => toast.success(message);
	
	const [novoLogin, setNovoLogin] = useState(initialState)
	const [loading, setLoading] = useState(false)
	
	useEffect(() => {
		// preenche o e-mail que já foi informado na página anterior([...]/enviar-email)
		// parametro do useNavigate, acessa a informação com o useLocation
		if(location?.state?.email){
			setNovoLogin(prevState => ({ ...prevState, email: location.state.email}));
		}else{
			navigate("/enviar-email")
		}
	}, [location?.state?.email]);
	
	const handlePassword = e => {
		setNovoLogin(prevState => ({ ...prevState, senha: e.target.value}));
	}
	
	async function postRecuperarSenhaForm(e){
		e.preventDefault();
		let urlPost = URLBASE + "/recuperar-senha"
		try{
			if(checaFormatoSenha(novoLogin.senha)){
				setLoading(true)
				const response = await fetch(urlPost, {
							method: 'POST',
							headers: {
							'Accept': 'application/json',
							'Content-Type': 'application/json',
							'Access-Control-Allow-Origin': 'POST',
							},
							body: JSON.stringify({
								email: novoLogin.email,
								novaSenha: novoLogin.senha,
								pinUsuario: novoLogin.pinUsuario,
							})
						});
						const content = await response.json();
						if(content.status === "True"){
							notificationSuccess(content.mensagem);
						}else{
							notificationError(content.mensagem);
						}
			}else{
				notificationError('Formulário incorreto.');
			}
		}catch(error){
			notificationError('Um erro interno ocorreu.');
		}finally{
			setLoading(false)
		}
	}
	
	return (
	

					<div id="row-recuperar-senha" className="row">
						<div className="col-sm coluna-lateral"></div>
						<div className="col-lg-4 custom-col">
						<div id="recuperar-senha" className="card shadow-sm rounded">
						
							<center><p>Digite o código que você recebeu em seu e-mail e a sua nova senha</p></center>
		
							<form style={{marginTop: "10px"}} onSubmit={postRecuperarSenhaForm}>
							  
							  <input placeholder="E-mail" id="email" type="email" required name="email" className="form-control shadow-none" value={novoLogin.email} disabled/><br/>
							  
							  <input placeholder="Código recebido" id="pin" type="text" required name="pin" className="form-control shadow-none" value={novoLogin.pinUsuario} onChange={(e) => setNovoLogin(prevState => ({ ...prevState, pinUsuario: e.target.value}))}/><br/>
							  
							  <PasswordInput placeholder="Nova senha" senha={novoLogin.senha} onChangeFunc={handlePassword} titleTooltip="clique para mostrar ou esconder a senha" tooltipPosition="top" checkPassword={true} />
							  <br/>

							  <button id="btn-recuperar-senha" className="btn shadow-none">{loading ? <Loader small={true} color={"#ffffff"} /> : 'Atualizar senha'}</button><br/>	
								
							  
							</form>
							
							<center><small><Link to="/">Voltar</Link></small></center>						
						
						</div>
						</div>
						<div className="col-sm coluna-lateral"></div>
					</div>

	
	)
}
	

export default RecuperarSenha;
